<div class="cdr-legend-card" [class.collapsed]="!isExpanded">
  <!-- Legend Header -->
  <div class="legend-header" (click)="toggleCollapse($event)">
    <div class="header-title-wrap">
      <span class="pulse-indicator"></span>
      <span class="header-title">City / Region (No. of Towers)</span>
    </div>
    <div class="header-actions">
      <button
        class="legend-btn icon-btn"
        (click)="toggleLayer($event)"
        [title]="(isLayerVisible$ | async) ? 'Hide CDR Layer' : 'Show CDR Layer'"
      >
        <i class="fa-solid" [class.fa-eye]="isLayerVisible$ | async" [class.fa-eye-slash]="!(isLayerVisible$ | async)"></i>
      </button>
      <button class="legend-btn icon-btn collapse-btn" (click)="toggleCollapse($event)" title="Toggle Legend">
        <i class="fa-solid" [class.fa-chevron-down]="isExpanded" [class.fa-chevron-up]="!isExpanded"></i>
      </button>
    </div>
  </div>

  <!-- Legend Body (Region items list) -->
  @if (isExpanded) {
    <div class="legend-body">
      @if (regions$ | async; as regions) {
        <ul class="region-list">
          @for (region of regions; track region.name) {
            <li class="region-item" (click)="onCityClick(region.name, $event)" [title]="'Fly to ' + region.name">
              <span class="color-dot" [style.background-color]="region.color"></span>
              <span class="region-name">{{ region.name }}</span>
              <span class="tower-count">({{ region.count }})</span>
              <i class="fa-solid fa-location-crosshairs fly-icon"></i>
            </li>
          }
        </ul>
      }

      <!-- Total Footer -->
      <div class="legend-footer" (click)="onOverviewClick($event)" title="Click to view full Nigeria overview">
        <span class="total-text">Total: {{ totalTowers$ | async }} tower locations</span>
        <i class="fa-solid fa-earth-africa overview-icon"></i>
      </div>
    </div>
  }
</div>
